var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("div", [
        _c(
          "div",
          { staticStyle: { width: "65%" } },
          [
            _c("div", {
              staticStyle: {
                height: "30px",
                padding: "15px",
                "font-size": "16px"
              },
              attrs: { id: "jobInfoText" }
            }),
            _vm._v(" "),
            _c("hr", {
              staticStyle: { "margin-left": "25px", "margin-right": "25px" }
            }),
            _vm._v(" "),
            _vm.perms.includes("38")
              ? _c("layout-7", {
                  staticStyle: {
                    width: "100%",
                    height: "calc(100vh - 150px)",
                    float: "left"
                  },
                  attrs: {
                    id: _vm.pageid2,
                    term: _vm.term,
                    title: "Report Times",
                    edit_types: [
                      null,
                      "DateTime",
                      "DateTime",
                      "Value",
                      "TextArea",
                      null
                    ],
                    edit_perm: "39",
                    isAdd: true
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scroll",
            staticStyle: {
              width: "30%",
              height: "calc(100vh - 150px)",
              float: "right"
            }
          },
          [
            _c("document", {
              ref: "doc",
              attrs: {
                dir: "doc_" + parseInt(_vm.term) + ".jpg",
                doc_id: _vm.term
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _vm.perms.includes("17")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Edit")
                    }
                  }
                },
                [_vm._v("Edit Document")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("105")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Edit Service Report")
                    }
                  }
                },
                [_vm._v("Edit Service Report")]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55c94c68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c94c68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_Documents.vue
// module id = 544
// module chunks = 0